export const optionListData = [
  {
    category: 0,
    name: "계란찜",
    price: 0,
    isSale: true,
  },
  {
    category: 0,
    name: "김치찌개",
    price: 0,
    isSale: true,
  },
  {
    category: 1,
    name: "콜라",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "제로콜라",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "사이다",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "트레비 레몬",
    price: 2000,
    isSale: true,
  },
  {
    category: 1,
    name: "립톤 아이스티 (복숭아)",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "밀키스",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "탐스제로 파인애플",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "탐스제로 오렌지",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "탐스제로 애플키위",
    price: 1500,
    isSale: true,
  },
  {
    category: 1,
    name: "선택안함",
    price: 0,
    isSale: true,
  },
  {
    category: 2,
    name: "파채 없음",
    price: 0,
    isSale: true,
  },
  {
    category: 3,
    name: "김가루 없음",
    price: 0,
    isSale: true,
  },
  {
    category: 4,
    name: "라면 사리 반쪽",
    price: 1000,
    isSale: true,
  },
  {
    category: 4,
    name: "햄사리 추가",
    price: 1500,
    isSale: true,
  },
  {
    category: 4,
    name: "선택안함",
    price: 0,
    isSale: true,
  },
  {
    category: 5,
    name: "부대",
    price: 0,
    isSale: true,
  },
  {
    category: 5,
    name: "고기",
    price: 0,
    isSale: true,
  },
  {
    category: 6,
    name: "아주 매움",
    price: 0,
    isSale: true,
  },
  {
    category: 6,
    name: "조금 덜매움",
    price: 0,
    isSale: true,
  },
];
